export default function TermsAndConditions() {
  const styles = {
    container: {
      maxWidth: "800px",
      margin: "0 auto",
      padding: "2rem",
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
      lineHeight: 1.6,
      color: "#333",
    },
    h1: {
      color: "#2c3e50",
      marginBottom: "1rem",
      fontSize: "2rem",
    },
    effectiveDate: {
      color: "#666",
      fontStyle: "italic",
      marginBottom: "2rem",
    },
    introduction: {
      marginBottom: "2rem",
    },
    section: {
      marginBottom: "2.5rem",
    },
    h2: {
      color: "#2c3e50",
      fontSize: "1.5rem",
      marginBottom: "1rem",
      paddingBottom: "0.5rem",
      borderBottom: "2px solid #eee",
    },
    paragraph: {
      marginBottom: "1rem",
    },
    list: {
      listStyleType: "disc",
      marginLeft: "1.5rem",
      marginBottom: "1rem",
    },
    listItem: {
      marginBottom: "0.5rem",
    },
    contactInfo: {
      backgroundColor: "#f8f9fa",
      padding: "1.5rem",
      borderRadius: "8px",
      marginTop: "1rem",
    },
    link: {
      color: "#007bff",
      textDecoration: "none",
    },
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.h1}>Terms & Conditions – Work Permit (K Cement)</h1>
      <p style={styles.effectiveDate}>Effective Date: 11 April 2025</p>

      <p style={styles.introduction}>These Terms & Conditions govern your use of the Work Permit application developed by K Cement.</p>

      <section style={styles.section}>
        <h2 style={styles.h2}>1. Acceptance of Terms</h2>
        <p style={styles.paragraph}>By using the App, you agree to these terms. If you do not agree, please do not use the App.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>2. Use of the App</h2>
        <p style={styles.paragraph}>The App is intended for internal use by K Cement employees and authorized staff only to manage and request work permits for accessing different zones within the company. It streamlines zone-to-zone workflows and simplifies communication for permit requests.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>3. User Responsibilities</h2>
        <p style={styles.paragraph}>You agree:</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>To provide accurate and truthful information</li>
          <li style={styles.listItem}>Not to misuse or interfere with the App</li>
          <li style={styles.listItem}>To use the App only for its intended purpose</li>
        </ul>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>4. Authentication</h2>
        <p style={styles.paragraph}>Access is granted via secure OAuth login linked to your K Cement account.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>5. Intellectual Property</h2>
        <p style={styles.paragraph}>All content, design, and code in the App is the property of K Cement. You may not reproduce, distribute, or create derivative works without written permission.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>6. Limitation of Liability</h2>
        <p style={styles.paragraph}>K Cement is not liable for any indirect damages or data loss resulting from your use of the App.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>7. Modifications</h2>
        <p style={styles.paragraph}>We may update these terms as needed. Continued use of the App indicates your acceptance of any changes.</p>
      </section>

      <section style={styles.section}>
        <h2 style={styles.h2}>8. Contact Information</h2>
        <p style={styles.paragraph}>For questions or support, contact:</p>
        <div style={styles.contactInfo}>
          <p style={styles.paragraph}>
            Email:{" "}
            <a href="mailto:chorks@scg.com" style={styles.link}>
              chorks@scg.com
            </a>
          </p>
          <p style={styles.paragraph}>
            Phone:{" "}
            <a href="tel:+855888081453" style={styles.link}>
              +855 888081453
            </a>
          </p>
          <p style={styles.paragraph}>Address: Kampot Cement Co., Ltd.</p>
          <p style={styles.paragraph}>No.43, 5th Floor Maybank Tower,</p>
          <p style={styles.paragraph}>Preah Norodom Boulevard,</p>
          <p style={styles.paragraph}>Sangkat Phsar Thmey III,</p>
          <p style={styles.paragraph}>Khan Daun Penh,</p>
          <p style={styles.paragraph}>Phnom Penh 120203,</p>
          <p style={styles.paragraph}>Cambodia</p>
        </div>
      </section>
    </div>
  );
}
